import { render, staticRenderFns } from "./language-items-primary.vue?vue&type=template&id=23fb2642&scoped=true&"
import script from "./language-items-primary.vue?vue&type=script&lang=js&"
export * from "./language-items-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fb2642",
  null
  
)

export default component.exports